import { useState } from "react";
import { Search } from "lucide-react";
import ProviderCard from "../components/ProviderCard";
import { PROVIDERS, ODOR_TYPES, PROPERTY_TYPES, METHOD_TYPES, CERT_TYPES } from "../mock";
import { useContent } from "../context/ContentContext";

function Select({ options, value, onChange }) {
  return (
    <select value={value} onChange={(e) => onChange(e.target.value)} className="h-12 w-full rounded-xl border border-slate-200 bg-white px-4 text-[14px] font-medium text-[var(--ink)] outline-none transition-colors focus:border-[var(--brand-blue)]">
      {options.map((o) => <option key={o} value={o}>{o}</option>)}
    </select>
  );
}

export default function Providers() {
  const { c } = useContent();
  const pp = c.providersPage;
  const [query, setQuery] = useState("");
  const [method, setMethod] = useState(METHOD_TYPES[0]);
  const [cert, setCert] = useState(CERT_TYPES[0]);
  const [odor, setOdor] = useState(ODOR_TYPES[0]);
  const [prop, setProp] = useState(PROPERTY_TYPES[0]);

  const list = PROVIDERS.filter((p) => {
    const q = query.toLowerCase();
    const matchQ = p.name.toLowerCase().includes(q) || p.desc.toLowerCase().includes(q) || p.location.toLowerCase().includes(q);
    const matchM = method === METHOD_TYPES[0] || p.tags.some((t) => t.includes(method)) || (p.method || "").includes(method);
    const matchC = cert === CERT_TYPES[0] || p.tags.includes(cert);
    return matchQ && matchM && matchC;
  });

  return (
    <main>
      <section className="bg-[var(--navy)] py-16 lg:py-20">
        <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
          <p className="text-[12px] font-bold uppercase tracking-[0.14em] text-[#5aa0e0]">{pp.heroEyebrow}</p>
          <h1 className="font-display mt-3 text-[38px] font-extrabold leading-tight tracking-tight text-white sm:text-[48px]">{pp.heroTitle}</h1>
          <p className="mt-4 max-w-2xl text-[17px] leading-relaxed text-slate-300">{pp.heroSubtitle}</p>
        </div>
      </section>

      <section className="bg-[#f7f8fa] py-14 lg:py-16">
        <div className="mx-auto max-w-[1200px] px-5 lg:px-8">
          <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-[0_10px_40px_-28px_rgba(15,36,56,0.35)]">
            <div className="flex items-center gap-3 rounded-xl border border-slate-200 px-4">
              <Search size={18} className="text-slate-400" />
              <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Search company, city, ZIP, method, odor type..." className="h-12 flex-1 bg-transparent text-[15px] text-[var(--ink)] outline-none placeholder:text-slate-400" />
            </div>
            <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
              <Select options={ODOR_TYPES} value={odor} onChange={setOdor} />
              <Select options={PROPERTY_TYPES} value={prop} onChange={setProp} />
              <Select options={METHOD_TYPES} value={method} onChange={setMethod} />
              <Select options={CERT_TYPES} value={cert} onChange={setCert} />
            </div>
          </div>

          <p className="mt-6 text-[14px] font-semibold text-slate-500">{list.length} providers found</p>

          <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {list.map((p) => <ProviderCard key={p.slug} p={p} />)}
          </div>
          {list.length === 0 && (
            <div className="mt-10 rounded-2xl border border-dashed border-slate-300 bg-white p-12 text-center text-slate-500">No providers match your search.</div>
          )}
        </div>
      </section>
    </main>
  );
}
